import { render, staticRenderFns } from "./leftTab.vue?vue&type=template&id=83c5850c&scoped=true&"
import script from "./leftTab.vue?vue&type=script&lang=js&"
export * from "./leftTab.vue?vue&type=script&lang=js&"
import style0 from "./leftTab.vue?vue&type=style&index=0&id=83c5850c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c5850c",
  null
  
)

export default component.exports